import React from "react";

import GetIcon from "Components/Global/Icons";

import { Wrapper } from "./styles";

// eslint-disable-next-line no-undef
const images = require.context("Components/Global/Icons/Components", true);
const imageList = images.keys().map((image) => images(image));
const imageSet = new Set(imageList);

function ImageGallery() {
  return (
    <Wrapper>
      {[...imageSet].map((image, index) => (
        <div
          onClick={() => {
            navigator.clipboard.writeText(image.default.name);
          }}
          key={index}
        >
          <GetIcon name={image.default.name} />

          <span>{image.default.name}</span>
        </div>
      ))}
    </Wrapper>
  );
}

export default ImageGallery;
